import {useEffect, useState} from "react";
import {useLocation, useHistory, Route} from "react-router-dom";
import Content from "./Content";
import {langContext, agentContext, messageContext} from "commons/contexts";
import {domain} from "commons/config";
import MessageBox from "Content/MessageBox";
import PopupForm from "Content/PopupForm";

const langs = ["nl", "fr", "sp"];
function Enclose() {
    const [lang, setLang] = useState<string>("nl");
    const [agentData, setAgentData] = useState({});

    const [message, setMessage] = useState(null);


    const location = useLocation();
    const history = useHistory();

    function checkLang(path: string): boolean | string {
        if (!path) return true;
        if (path.length < 2) return false;
        if (langs.indexOf(path.split("/")[1]) < 0) return false;

        return path.split("/")[1];
    }

    useEffect(() => {
        const curLang = checkLang(location.pathname);
        if (!curLang) {
            document.location.replace("/" + langs[0]);
            return;
        }

        if (curLang !== lang) {
            setLang(curLang as string)
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        const curLang = checkLang(location.pathname);
        if (!curLang) return;
        if (curLang !== lang) {
            const curpath = location.pathname;
            const paths = curpath.split("/");
            paths[1] = lang;
            history.push(paths.join("/") + location.search);
        }
        //eslint-disable-next-line
    }, [lang]);

    useEffect(() => {
        const searchParams = Object.fromEntries((new URLSearchParams(location.search)))
        const soid = searchParams.soid;
        if (!soid) return;
        console.log("DA DATA", "hi");

        fetch(domain + "/getAgentData", {method: "POST", body: JSON.stringify({id: soid})}).then(response => {
            response.json().then(json => {
                setAgentData(json);
                console.log("DA DATA", json);
            })
        })
        //eslint-disable-next-line
    }, []);

    return (
        <langContext.Provider value={{lang, setLang, langs}}>
            <agentContext.Provider value={{agentData}}>
                <messageContext.Provider value={{message, setMessage}}>
                    <Route path="/:lang">
                        <PopupForm />
                        <MessageBox />
                        <Content />
                    </Route>
                </messageContext.Provider>
            </agentContext.Provider>
        </langContext.Provider>
    )
}

export default Enclose;